export function hamburger(){
    const button = document.body.querySelector('.js_ham_btn');
    const nav = document.body.querySelectorAll('.el_hamburger_nav a');

    button.addEventListener('click',()=>{
        //const scrollbarWidth = window.innerWidth - document.body.clientWidth;
        //document.body.style.paddingRight = scrollbarWidth+'px';
        if (!document.body.classList.contains('fancybox-active')) {
            document.body.classList.toggle('hamburger-show');
        }
    })

    nav.forEach(elm => {
        elm.addEventListener('click',()=>{
            document.body.classList.remove('hamburger-show');
        })
    })
}
